<template>
    <el-dialog
        :title="(isForm ? (alarmItem.id ? '编辑' : '添加事件') : '查看') + dialogTitle"
        :model-value="modelValue"
        width="500px"
        @close="closed"
        align-center
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="isForm ? formRules : {}"
            label-width="140px"
            style="max-width: 560px"
        >
            <el-row>
                <el-col :span="24">
                    <el-form-item label="级别名称" prop="label">
                        <el-input style="width: 300px" v-model="formData.label" placeholder="请输入告警名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="级别编码" prop="code">
                        <el-input style="width: 300px" disabled v-model="formData.code" placeholder="请输入告警编码"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="等级" prop="level">
                        <el-input-number
                            style="width: 200px"
                            disabled
                            v-model="formData.level"
                            :min="0"
                            :max="20"
                            placeholder="请输入等级"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="报警音频" prop="audio">
                        <el-input
                            style="width: 300px"
                            disabled
                            v-model="formData.audio.split('/')[2]"
                            placeholder="报警音频"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="报警颜色" prop="color">
                        <el-color-picker v-model="formData.color" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="是否文字闪烁" prop="flicker">
                        <el-radio-group v-model="formData.flicker" class="ml-4">
                            <el-radio :value="1" size="large">闪烁</el-radio>
                            <el-radio :value="0" size="large">不闪烁</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="是否前台显示" prop="display">
                        <el-radio-group v-model="formData.display" class="ml-4">
                            <el-radio :value="1" size="large">显示</el-radio>
                            <el-radio :value="0" size="large">不显示</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="声光报警" prop="sound_light">
                        <el-radio-group v-model="formData.sound_light" class="ml-4">
                            <el-radio :value="1" size="large">是</el-radio>
                            <el-radio :value="0" size="large">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="报警短信发送" prop="is_message">
                        <el-radio-group v-model="formData.is_message" class="ml-4">
                            <el-radio :value="1" size="large">是</el-radio>
                            <el-radio :value="0" size="large">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="触发联动摄像头录制" prop="is_record">
                        <el-radio-group v-model="formData.is_record" class="ml-4">
                            <el-radio :value="1" size="large">是</el-radio>
                            <el-radio :value="0" size="large">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="告警描述" prop="remark">
                        <el-input
                            style="width: 300px"
                            type="textarea"
                            v-model="formData.remark"
                            placeholder="告警描述"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'

import { getAlarmLevelSettingDetail, putLevel } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import { ElMessage } from 'element-plus'
// import { validatePassword } from '@/utils/rules.js'
// import { Download, Plus, UploadFilled } from '@element-plus/icons'
// import { LOCALFS_ROOT } from '@/constant'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    alarmItem: {
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

// 表单源
const formData = ref({
    id: '',
    label: '',
    code: '',
    audio: '',
    level: 0,
    flicker: 0,
    display: 0,
    module: 'cctv',
    status: 1,
    visible: 1
})
// 验证规则

const formRules = ref({
    // name: [
    //     {
    //         required: true,
    //         trigger: 'blur',
    //         message: '事件名称为必填项'
    //     }
    // ],
    // code: [
    //     {
    //         required: true,
    //         message: '事件编码为必填项',
    //         trigger: 'blur'
    //     }
    // ],
    // level: [
    //     {
    //         required: true,
    //         trigger: 'blur',
    //         message: '事件等级为必填'
    //     }
    // ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.alarmItem.id !== '') {
        await doPutLevel()
    } else {
        // await doAddCameraPoint()
    }
}
// 提交data数据修饰
const getPostFormData = () => {
    const postFormData = {}
    if (formData.value.id) {
        postFormData.id = formData.value.id
    }

    postFormData.level = formData.value.level
    postFormData.label = formData.value.label
    postFormData.audio = formData.value.audio
    postFormData.color = formData.value.color
    postFormData.remark = formData.value.remark
    postFormData.flicker = formData.value.flicker ? '1' : '0'
    postFormData.display = formData.value.display ? '1' : '0'
    postFormData.sound_light = formData.value.sound_light ? '1' : '0'
    postFormData.is_message = formData.value.is_message ? '1' : '0'
    postFormData.is_record = formData.value.is_record ? '1' : '0'
    return postFormData
}

// 修改
const doPutLevel = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        // await putEquipModel(formData.value)
        try {
            await putLevel(postFormData)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// // 添加
// const doAddCameraPoint = async () => {
//     // 进行表单校验
//     formRef.value.validate(async (valid) => {
//         if (!valid) return
//         submitLoading.value = true
//         const postFormData = getPostFormData()
//         // await addEquipModel(formData.value)
//         try {
//             await addEventSource(postFormData)
//             // 模块添加成功
//             emits('updateForm')
//             ElMessage.success('添加成功！')
//             submitLoading.value = false
//             closed()
//         } catch {
//             submitLoading.value = false
//         }
//     })
// }

const loading = ref(false)
// 获取点位详情
const getEventDetail = async () => {
    loading.value = true
    const res = await getAlarmLevelSettingDetail(props.alarmItem.id)
    console.log(res)
    formData.value = res
    loading.value = false
}

onMounted(async () => {
    if (props.alarmItem) {
        getEventDetail()
    } else {
        formData.value = {
            id: '',
            name: '',
            code: '',
            level: '',
            module: 'cctv',
            status: 1,
            visible: 1
        }
    }
})
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 36px;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
body {
    margin: 0;
}
.example-showcase .el-loading-mask {
    z-index: 9;
}
</style>
